module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_4.e5cabc80.png";